import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CrossSellProductEventValidator } from "./crosssellproductevent.validator";
import {
  CrossSellProduct,
  CrossSellProductCategory,
  CrossSellProductCategoryService,
  CrossSellProductService,
  CrossSellProductVariantService,
  CrossSellProductVariantView,
  EventType
} from "../../api";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../services/auth.service";
import { KeyValuePair, ValidationMessage } from '@tymes4-shared';
import {EventCrossSellProductDetailsView} from "../../api/model/eventCrossSellProductDetailsView";

type CrossSellProductWithTranslatedName = CrossSellProduct & { TranslatedName: string };

@Component({
    selector: 'app-edit-crosssell-product-event',
    templateUrl: './edit-crosssell-product-event.component.html',
    standalone: false
})
export class EditCrossSellProductEventComponent implements OnInit {

    public selectedEventId: number;
    public selectedEventType: EventType;

    public categories: any;
    public products: CrossSellProductWithTranslatedName[];
    public variants:  any;

    public isNew: boolean;
    public form: FormGroup;
    public activeTenantShopId: number;
    private isInArchiveMode = this.authService.isInArchiveMode();

    validationMessages: KeyValuePair<ValidationMessage[]> = {};

    constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
                public dialogRef: MatDialogRef<EditCrossSellProductEventComponent>,
                private crossSellProductCategoryService: CrossSellProductCategoryService,
                private crossSellProductService: CrossSellProductService,
                private crossSellProductVariantService: CrossSellProductVariantService,
                private authService: AuthService,
                private translateService: TranslateService) { }


    ngOnInit() {
      this.isNew = this.passedData.isNew;
      this.selectedEventId = this.passedData.eventId;
      this.selectedEventType = this.passedData.eventType;
      this.activeTenantShopId = this.passedData.activeTenantShop.Id;

      const o = {
        EventId: this.passedData.eventId,
        EventType: this.passedData.eventType,
      };

    this.form = new FormGroup({
        CategoryId: new FormControl(''),
        ProductId: new FormControl(''),
        ProductVariants: new FormControl('', {validators: Validators.required}),
        OnSaleFrom: new FormControl('', { validators: Validators.required }),
        OnSaleTill: new FormControl('',{ validators: Validators.required }),
        GroupingId: new FormControl(''),
        EventId: new FormControl(''),
        EventType: new FormControl(''),
        IsNew: new FormControl(''),
        TenantShopId: new FormControl(this.activeTenantShopId)
     } ,CrossSellProductEventValidator.ValidateDates);

      this.crossSellProductCategoryService.crossSellProductCategoryGetAll().subscribe((categories: CrossSellProductCategory[]) => {
            this.categories = categories;
        });

      if (this.isNew) {
        this.form.patchValue(o);
      }
      else {
        this.form.patchValue(o);

        this.crossSellProductVariantService.getByGroupingId(this.passedData.payload.GroupingId).subscribe((data: EventCrossSellProductDetailsView[]) => {
          if (!data) {
            return;
          }

          this.updateProducts(data[0].CategoryId);
          this.updateVariants(data[0].ProductId);

          const patches = {
            CategoryId: data[0].CategoryId,
            ProductId: data[0].ProductId,
            ProductVariants: data.map(x => x.VariantId),
            GroupingId: data[0].GroupingId,
            OnSaleFrom: data[0].OnSaleFrom,
            OnSaleTill: data[0].OnSaleTill,
          };
          this.form.patchValue(patches);
        });
      }

      if (this.isInArchiveMode)
        this.form.disable()
    }


    submit() {
        const frm = this.form.value;

        frm.IsNew = this.isNew;

        // this.loader.open();
        if (this.isNew) {
          this.crossSellProductVariantService.createEventVariants(frm).subscribe((id: number[]) => {
            // close this dialog and pass the newly added id to the called
            this.dialogRef.close(id);
            // this.loader.close();
          });
        } else {
          this.crossSellProductVariantService.updateEventVariants(frm).subscribe(() => {
            this.dialogRef.close(frm.GroupingId);
          });
        }
    }

    onCategoryChange(item) {
        // get products for cat
        this.form.controls.ProductId.setValue(null);
        this.form.controls.ProductVariants.setValue(null);
        if (item.Id!=null) {
           this.updateProducts(item.Id);
        }
    }

    updateProducts(categoryId) {
        this.crossSellProductService.getCrossSellProductByCategory(categoryId).subscribe((products: CrossSellProduct[]) => {
            this.products = products.map(product => ({
              ...product,
              TranslatedName: this.translateService.instant(product.Name ?? '')
            }));
        });
    }

    onProductChange(item) {
        // get event variants
        this.form.controls.ProductVariants.setValue(null);
        if (item.Id!=null) {
          this.updateVariants(item.Id);
        }
    }

    updateVariants(productId) {
        this.crossSellProductVariantService.getByProduct(productId).subscribe((variants: CrossSellProductVariantView[]) => {
            this.variants = variants;
        });
    }
}
